import { Box, Grid2 } from '@mui/material';
import React, { useState } from 'react';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import CustomCard from '@ui-components/Card/CustomCard';
import CustomLink from '@ui-components/Link/CustomLink';
import { useLocation } from 'react-router-dom';
//Icon
import CustomCardContent from '@ui-components/Card/CustomCardContent';

//Css
import './moredetails.css';
import CustomTabs from '@ui-components/Tabs/CustomTabs';
import CustomTabPanel from '@ui-components/Tabs/CustomTabPanel';
import CustomDivider from '@ui-components/Divider/CustomDivider';
import PastSession from './PastSession';
import SessionDoc from './SessionDoc';

import type { SessionDetails } from '../../API/services/consultMoreDetailsService';
import ConsultHistory from '@qler-view/shared_lib/src/shared/History/ConsultHistory';
import { useConsultHistory } from '../../shared/History/consultHistorySetup';
import { PORTAL_TYPES } from '@qler-view/shared_lib/src/shared/constants/portalType';
import {
  formatFieldValue,
  isValidUrl,
} from '@qler-view/shared_lib/src/reusableFunctions/CommonFunctions';

type ConsultFacilityDetailsProps = {
  consultFacilityDetails: SessionDetails;
};

// Helper function to check if a string is a valid URL

const FacilityDetails: React.FC<ConsultFacilityDetailsProps> = ({
  consultFacilityDetails,
}) => {
  // Function to receive count from child

  const location = useLocation();
  const [activeTab, setActiveTab] = useState<number | string>(
    location.state?.cameFromBack ? 1 : 0
  );
  const [consultId] = useState(location.state?.consultId ?? 0);

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: number | string
  ) => {
    setActiveTab(newValue);
  };

  const { consultHistory, isLoading } = useConsultHistory(
    consultId,
    PORTAL_TYPES.CLINICAL
  );

  const tabItems = [
    { label: 'Facility Fields', value: 0 },
    {
      label:
        'Past Consults ' + '(' + consultFacilityDetails.pastSessionCount + ')',
      value: 1,
    },
    {
      label:
        'Consult Documents ' +
        '(' +
        consultFacilityDetails.sessionDocumentCount +
        ')',
      value: 2,
    },
    { label: 'History', value: 3 },
  ];

  return (
    <Box>
      <Grid2 container>
        <CustomCard id="patient-details" className="width-100">
          <CustomCardContent
            id="patient-details-content"
            className="card-content facility-card-content"
          >
            <Box>
              <CustomTabs
                id="facility-details-tab"
                tabs={tabItems}
                value={activeTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                allowScrollButtonsMobile={true}
                orientation="horizontal"
              />
              <CustomDivider />
            </Box>
            <Box>
              <CustomTabPanel value={activeTab} index={0} className="pb-none">
                <Box>
                  <Grid2 container spacing={0.5} className="text-align-left">
                    {consultFacilityDetails &&
                    consultFacilityDetails.facilityDetails.length > 0 ? (
                      consultFacilityDetails.facilityDetails.map(
                        (field, index) => {
                          return (
                            <Grid2
                              key={`${field.fieldLabel}-${index}`}
                              size={{
                                xs: 12,
                                sm: 12,
                                md: 4,
                                lg: 2.4,
                                xl: 2.4,
                              }}
                              className="text-left pb-24"
                            >
                              <Box>
                                <CustomTypography
                                  id={`lbl-${field.fieldLabel}-label`}
                                  variant="body2"
                                  color="textSecondary"
                                  className="pb-4"
                                >
                                  {field.fieldLabel}
                                </CustomTypography>
                                {isValidUrl(field.fieldValue) ? (
                                  <CustomLink
                                    id={`lbl-${field.fieldLabel}-value`}
                                    variant="body3"
                                    className="content-align"
                                    href={
                                      field.fieldValue?.startsWith('http://') ||
                                      field.fieldValue?.startsWith('https://')
                                        ? field.fieldValue
                                        : `https://${field.fieldValue}`
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    underline="hover"
                                    color="primary"
                                  >
                                    {field.fieldValue}
                                  </CustomLink>
                                ) : (
                                  <CustomTypography
                                    id={`lbl-${field.fieldLabel}-value`}
                                    variant="body3"
                                    className="content-align"
                                  >
                                    {formatFieldValue(field.fieldValue)}
                                  </CustomTypography>
                                )}
                              </Box>
                            </Grid2>
                          );
                        }
                      )
                    ) : (
                      <Grid2
                        size={{ xs: 12, sm: 12, md: 4, lg: 2.4, xl: 2.4 }}
                        className="button-width"
                      >
                        <Box className="text-align-center no-consults-data">
                          <CustomTypography
                            variant="body2"
                            color="textDisabled"
                            id="no-details-available-text"
                          >
                            No Details Available
                          </CustomTypography>
                        </Box>
                      </Grid2>
                    )}
                  </Grid2>
                </Box>
              </CustomTabPanel>
              <CustomTabPanel value={activeTab} index={1}>
                <CustomTypography id="" variant="body2">
                  <Box>
                    <Grid2 container>
                      <Grid2
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        className="text-left"
                      >
                        <PastSession />
                      </Grid2>
                    </Grid2>
                  </Box>
                </CustomTypography>
              </CustomTabPanel>
              <CustomTabPanel value={activeTab} index={2}>
                <Box>
                  <Grid2 container>
                    <Grid2
                      size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                      className="text-align-end"
                    ></Grid2>
                  </Grid2>
                </Box>

                <Box>
                  <Grid2 container>
                    <Grid2
                      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                      className="text-left"
                    >
                      <SessionDoc />
                    </Grid2>
                  </Grid2>
                </Box>
              </CustomTabPanel>
              <CustomTabPanel value={activeTab} index={3}>
                <CustomTypography id="" variant="body2">
                  <Box>
                    <Grid2 container>
                      <Grid2
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        className="text-left"
                      >
                        {consultHistory && (
                          <ConsultHistory
                            consultHistory={consultHistory}
                            isLoading={isLoading}
                          />
                        )}
                        {!consultHistory && !isLoading && (
                          <Box>No consultation history found</Box>
                        )}
                        {isLoading && <Box>Loading...</Box>}
                      </Grid2>
                    </Grid2>
                  </Box>
                </CustomTypography>
              </CustomTabPanel>
            </Box>
          </CustomCardContent>
        </CustomCard>
      </Grid2>
    </Box>
  );
};

export default FacilityDetails;
